<i18n src='@/locale/patient-localization.json'></i18n>
<i18n src='@/locale/kadr-localization.json'></i18n>

<template>
    <v-container>
        <v-data-table
            dense
            :headers="headers"
            :options.sync="options"
            :items="gridData"
            :server-items-length="gridDataTotalCount"
            class="elevation-1 row-pointer"
            :footer-props="footerProps"
            @click:row="$emit('clickedOnRow',$event)"
            @contextmenu:row="show"
        >
            <template v-slot:header.DoctorFullName="{ header }">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    class="mt-1"
                    v-model="researchFilter.DoctorFullName"
                    @change="OnSearch"
                    :label="$t('Doctor')"
                ></v-text-field>
            </template>
            <template v-slot:header.Service="{ header }">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    class="mt-1"
                    v-model="researchFilter.Service"
                    @change="OnSearch"
                    :label="$t('Grid_Research_Info_Services_Service')"
                ></v-text-field>
            </template>
            <template v-slot:header.Insurance="{ header }">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    class="mt-1"
                    v-model="researchFilter.Insurance"
                    @change="OnSearch"
                    :label="$t('Grid_DoctorReceive_Insurance')"
                ></v-text-field>
            </template>
            <template v-slot:item.DateTimeFrom="{ item }">
                {{ FormatDate(item.DateTimeFrom) }}
            </template>
        </v-data-table>
        <v-menu
            v-model="showMenu"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
        >
            <v-list dense>
                <v-list-item-group>
                    <v-list-item v-for="(item,i) in formsData" :key="i"
                                 @click="$emit('showIframe',item,selectedItem,i)">
                        <v-list-item-title>{{ item.FormElName.Name }}</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <div class='d-flex justify-center px-2 pt-2'> 
                        <v-btn
                            small
                            color="success"
                            class="mr-1"
                        >
                            დაიწყო
                        </v-btn>
                        <v-btn
                        v-if="showButton(2)"
                            small
                            color="info"
                            class="mx-1"
                        >
                            ჩატარდა
                        </v-btn>
                        <v-btn
                        v-if="showButton(0)"
                            small
                            class="ml-1"
                            color="error"
                        >
                            გაუქმდა
                        </v-btn>
                    </div>
                </v-list-item-group>
            </v-list>
        </v-menu>
    </v-container>
</template>

<script>
import VWmCreateEditDialog from '@/component/nosology/create-edit-dialog.vue';
import {getDateStr} from '@/script/common';
import researchService from "@/service/research-service";

export default {
    components: {
        VWmCreateEditDialog,
    },
    props: ["personHistoryCode", "diagnosisId"],
    created() {
        this.ReloadGrid()
    },
    data() {
        return {
            footerProps: {
                itemsPerPageOptions: [10, 25, 50, 100],
                showFirstLastPage: true,
                firstIcon: 'first_page',
                lastIcon: 'last_page',
                prevIcon: 'navigate_before',
                nextIcon: 'navigate_next',
            },
            researchFilter: {
                DoctorFullName: null,
                Service: null,
                Insurance: null
            },
            historyFilter: {
                HistoryNumber: null,
                HistoryType: null
            },
            diagnosisFilter: {
                dateFrom: null,
                dateTill: null,
                number: null,
            },
            headers: [
                {
                    text: this.$t('inf'),
                    value: 'NumberAndAmount',
                    sortable: false,
                },
                {text: this.$t('DateTimeFrom'), value: 'DateTimeFrom', sortable: false},
                {text: this.$t('Doctor'), value: 'DoctorFullName', sortable: false},
                {text: this.$t('Grid_Research_Price_And_Sponsor'), value: 'PriceAndSponsor', sortable: false},
                {text: this.$t('Grid_Research_Payment_And_Debt'), value: 'PaymentAndDebt', sortable: false},
                {text: this.$t('Grid_DoctorReceive_Insurance'), value: 'Insurance', sortable: false},
                {text: this.$t('Grid_Research_Info_Services_Service'), value: 'Service', sortable: false}
            ],
            gridData: [],
            gridDataTotalCount: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            lastSearch: null,
            showMenu: false,
            x: 0,
            y: 0,
            formsData: [],
            selectedItem: {}
        };
    },

    watch: {
        'options.page'() {
            this.ReloadGrid();
        },
        'options.itemsPerPage'() {
            this.ReloadGrid();
        }
    },

    methods: {
        OnSearch() {
            // if (this.lastSearch !== this.filter.search) {
            if (this.options.page === 1) {
                this.ReloadGrid();
            } else {
                this.options.page = 1;
            }
            // }
        },
        ReloadGrid(paramCode) {
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            const code = paramCode || this.personHistoryCode
            researchService
                .getGridData(page, itemsPerPage, {HistoryCode: code})
                .then((data) => {
                    this.gridData = data.data;
                    // შესაცვლელია data.total-ით
                    this.gridDataTotalCount = data.data.length;
                    // emit data
                    this.$emit('researchData', data.data)
                });
        },
        FormatDate(date) {
            return getDateStr(date, {withoutTimezone: true});
        },
        show(e, item) {
            this.formsData = item.item.ElFormsData
            this.selectedItem = item.item
            this.DocDone = item.item.DocDone
            e.preventDefault()
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
        },
        showButton(val) {
            return val !== this.DocDone
        }
    },
};
</script>

<style scoped>
.row-pointer > .v-data-table__wrapper > table > tbody > tr:hover {
    cursor: pointer;
}

.wm-price-no-wrap {
    white-space: nowrap;
}

.container {
    max-width: 100% !important;
}
</style>
